//Module Keys
let locales = {
   id: "Id",
   serialNumber: "Serial Number",
   iccid: "ICCID",
   hardwareModel: "Hardware Model",
   hardwareVersion: "Hardware Version",
   firmware: "Firmware",
   firmwareShort: "Firmware Short",
   firmwareNew: "Firmware New",
   rotate: "Rotate",
   drivingNightVision: "Driving Night Vision",
   mic: "Mic",
   mode: "Mode",
   simState: "Sim State",
   dataUsageInKB: "Data Usage In KB",
   SDCardStatus: "SD Card Status",
   cycle: "Cycles",
   isOnline: "Is Online",
   source: "Source",
   speed: "Speed",
   heading: "Heading",
   hDop: "hDop",
   vDop: "vDop",
   dmsStatus: "Dms Status",
   dmsCalibrated: "Dms Calibrated",
   size: "Size",
   bufferedSize: "Buffered Size",
   markedSize: "Marked Size",
   bufferedDuration: "Buffered Duration",
   markedDuration: "Marked Duration",
   markedDuration: "Marked Duration",
   lastDisconnectTime: "Last Disconnect Time",
   sysTime: "SysTime",
   time: "Time",
   time: "Time",
   lastConnectTime: "Last Connect Time",
   USING_PHONE: "Using Phone",
   SMOKING: "Smoking",
   DROWSINESS: "Drowsiness",
   NO_SEATBELT: "No Seatbelt",
   NO_DRIVER: "No Driver",
   DAYDREAMING: "Daydreaming",
   YAWN: "Yawn",
   ASLEEP: "Asleep",
   DISTRACTED: "Distracted",
   FORWARD_COLLISION: "Forward Collision",
   HEADWAY_MONITORING: "Headway Monitoring",
   LANE_DEPARTURE: "Lane Departure",
   power: "Power",
   eventTrigger: "Event Trigger",
   recording: "Recording",
   ATTENTIVE: "Attentive",
   HEADWAY_MONITORING_WARNING: "Headway Monitoring Warning",
   HEADWAY_MONITORING_EMERGENCY: "Headway Monitoring Emergency",
   LANE_DEPARTURE_WARNING: "Lane Departure Warning",
   FORWARD_COLLISION_WARNING: "Forward Collision Warning",
   STOP_SIGN_VIOLATION: "Stop Sign Violation",
   delayedPowerOff: "Delayed Power Off",
   liveStreamDuration: "Live Stream Duration",
   config: "Config",
   codec: "Codec",
   before: "Before",
   after: "After",
   timezone: "Timezone",
   speaker: "Speaker",
   enable: "Enable",
   on: "On",
   vehicleWidth: "Vehicle Width",
   sdCardEventSpace: "Sd Card Event Space",
   off: "Off",
   check: "Check",
   accValue: "Acc Value",
   brakeValue: "Brake Value",
   turnValue: "Turn Value",
   accDuration: "Acc Duration",
   brakeDuration: "Brake Duration",
   turnDuration: "Turn Duration",
   steps: "Steps",
   vidfleet_information: "Vidfleet Information",
   event_threshold: "Event Threshold",
   vidfleet_dms: "DMS",
   vidfleet_adas: "ADAS",
   vidfleet_sounds: "Sounds",
   vidfleet_night_vision: "Night Vision",
   vidfleet_auto_snapshot: "Auto Snapshot",
   vidfleet_live_stream_duration: "Live Stream Duration",
   vidfleet_record_config: "Record Config",
   vidfleet_privacy_mask: "Privacy Mask",
   vidfleet_volume: "Volume",
   vidfleet_running_info: "Running Info",

   vidfleet_complete_error_23: "Authentication failed",
   vidfleet_complete_error_24: "Not authorized",
   vidfleet_complete_error_204: "Sync camera error",
   vidfleet_complete_error_202: "Camera does not exist",
   vidfleet_complete_error_201: "Camera operation failed",
   vidfleet_complete_error_200: "Camera password error",
   vidfleet_device_info_error_default: "It is not possible to consult the information",
   virtualMode: "Virtual Mode",
   cameraSN: "Serial Number",
   vidfleet_start_time: "Start Time",
   vidfleet_end_time: "End Time",
   vidfleet_duration: "Duration",
   vidfleet_settings: "Settings",
   vidfleet_available_clips: "Available Clips",
   status: "Status",
   to: "To",
   from: "From",
   on: "On",
   Band: "Band",
   gpsStatus: "Gps Status",
   ecmStatus: "Ecm Status",
   SysTime: "System Time",
   angle: "Angle",
   vidfleet_from_db: "From DB",
   vidfleet_from_device: "From Device",
   vidfleet_noclipsavailable: "No Clips Available",
   vidfleet_updated_on: "The available clips were updated at"
};

export default locales;



